var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Upload',{staticClass:"upload-in-table",attrs:{"format":_vm.formatList,"before-upload":_vm.beforeUploadFile,"action":""}},[_c('Icon',{staticClass:"upload-icon",attrs:{"type":"md-cloud-upload","title":"上传"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-389ff894","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--0-1!./src/views/my-components/upload-in-table/upload-in-table.vue
// module id = null
// module chunks = 